<template>
  <div id="app" class="admin" v-bind:class="{ dark: darkmode }">
    <app-header :compact="true"></app-header>
    <admin-nav></admin-nav>
    <transition name="fade" mode="out-in">
      <router-view class="admin main" v-bind:class="{ dark: darkmode }"></router-view>
    </transition>
    <app-footer></app-footer>
  </div>
</template>

<script>
import AppHeader from '../common/Header'
import AppFooter from '../common/Footer'
import AdminNav from './AdminNav'
import router from '../../router'
export default {
  components: {
    AppHeader, AppFooter, AdminNav
  },
  data: () => {
    return {
      message: ""
    }
  },
  created: function(){
    let auth_token = this.$store.state.api_token
    if(!auth_token) { 
      router.push('/auth')
    }
  },
  computed: {
    darkmode() {
      return this.$store.state.darkmode
    },
  }
}
</script>
